module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0001#auto_bookmark_toc_1"
    }
  }, [_vm._v("Book Description")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_toc_1"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_toc_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_1"
    }
  }, [_vm._v("The Butlerian Jihad Period")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_3"
    }
  }, [_vm._v("Hunting Harkonnens")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_16"
    }
  }, [_vm._v("Whipping Mek")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_18"
    }
  }, [_vm._v("The Faces of a Martyr")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_20"
    }
  }, [_vm._v("Red Plague")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dune Period")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Silk")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Whisper of Caladan Seas")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Scattering")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea Child")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treasure in the Sand")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0008#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chronology of Dune Fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0009#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0010#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Liked …")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0011#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other WordFire Press Titles")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 66
// module chunks = 0